import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'doubleChamiliElafron';
const args = {};

export class DoubleChamiliElafron extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
